import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import styles from './style.js';
import {Button as MaterialButton} from '@material-ui/core';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#FFFFFF'
    }
  },
  overrides: {
    MuiButton: {
      outlinedPrimary: {
        width: '472px',
        marginLeft: '0.5%',
        height: '47px',
        borderRadius: '10px',
        backgroundColor: 'rgb(0,79,152)',
        transition: 'all ease-in .2s 0s',
        background: 'linear-gradient(0deg, rgba(9,80,153,1) 0%, rgba(6,58,112,1) 100%)',
        filter: 'progid:DXImageTransform.Microsoft.gradient(startColorstr="#095099",endColorstr="#063a70",GradientType=1)',
        '&:hover': {
          boxShadow: '0px 15px 11px -18px #000'
        }
      },
      raisedPrimary: {
        color: 'white'
      }
    }
  }
});

const Button = (props) => {

  return (
    <MuiThemeProvider theme={theme}>
      <MaterialButton variant={props.variant}
        color={props.color}
        className={props.className}
        classes={props.classes}
        onClick={props.onClick}
        type={props.type}
        component={props.component}
        to={props.to}
        disabled={props.disabled}
        style={props.style}
      >
        {props.icon}
        {props.text}
      </MaterialButton>
    </MuiThemeProvider>
  );
};

Button.propTypes = {
  variant: PropTypes.string,
  color: PropTypes.string,
  className: PropTypes.string,
  text: PropTypes.string,
  onClick: PropTypes.func,
  type: PropTypes.string,
  icon: PropTypes.element,
  component: PropTypes.func,
  to: PropTypes.string,
  disabled: PropTypes.bool
};

Button.defaultProps = {
  text: 'buttontext'
};

export default withStyles(styles)(Button);
